<template>
  <div class="manage-teachers-view">
    <header class="manage-teachers-view__header">
      <div class="manage-teachers-view__section">
        <h1 class="manage-teachers-view__title">Manage Teachers</h1>
        <button v-if="shouldEnrollTeachers()" @click="openAddTeacherModal" class="manage-teachers-view__button">
          <i class="manage-teachers-view__button__icon">
            <font-awesome-icon :icon="['fas', 'user-plus']" />
          </i>
        </button>
      </div>
      <RefreshBar v-if="lastRefreshDate" :last-refresh-date="lastRefreshDate" :updatable="false" />
    </header>
    <TeachersTable />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import RefreshBar from '@/components/RefreshBar';
import { FEATURES } from '@/constants';

import TeachersTable from './components/TeachersTable';

import ModalTeacherCreate from './components/forms/ModalTeacherCreate';
import constants from './components/forms/constants';

export default {
  name: 'TeachersList',

  components: {
    FontAwesomeIcon,
    TeachersTable,
    RefreshBar,
  },

  computed: {
    ...mapState('manageTeachers', ['lastRefreshDate']),
    ...mapGetters('features', ['canUseFeature']),
  },

  methods: {
    openAddTeacherModal() {
      this.$modal.show(ModalTeacherCreate, ...constants.modalConfig(this));
    },
    shouldEnrollTeachers() {
      return this.canUseFeature(FEATURES.MANAGE_TEACHERS_ENROLLMENT);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/mixins';
@import '~styles/tools/variables';

.manage-teachers-view {
  &__header {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row;
    justify-content: space-between;
    margin-bottom: 24px;
  }

  &__title {
    @include pageTitle;
  }

  &__section {
    display: flex;
    gap: 24px;
    align-items: center;
  }

  &__button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 35px;
    height: 35px;
    cursor: pointer;
    background: transparent;
    border-radius: 50%;
    border: 2px solid white;
    color: white;

    &:hover {
      border-color: $default-blue;
      color: $default-blue;
    }
  }

  &__button__icon {
    font-size: 14px;
    display: inline-block;
    position: relative;
  }
}
</style>
